import { useState } from 'react'
import { Platform, Pressable, StyleSheet, Text } from 'react-native'
import { colors, fontFamily } from '../tokens'

const SITE_URL =
  process.env.EXPO_PUBLIC_SITE_URL?.trim() ??
  (Platform.OS === 'web' && typeof window !== 'undefined' ? window.location.origin : '')

const buildShareUrl = (bandCheckId: string) => `${SITE_URL}/result?id=${bandCheckId}`

export const BandCheckShareButton = ({ bandCheckId }: { bandCheckId: string }) => {
  const [copied, setCopied] = useState(false)
  if (Platform.OS !== 'web' || typeof navigator === 'undefined' || !navigator.clipboard) {
    return null
  }
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(buildShareUrl(bandCheckId))
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // clipboard denied — silent; user can copy from URL bar if we expose it later
    }
  }
  return (
    <Pressable accessibilityRole="button" onPress={onCopy} style={styles.share}>
      <Text style={styles.shareText}>{copied ? 'Link copied ✓' : 'Copy link to result'}</Text>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  share: {
    marginTop: 24,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: colors.primary[500],
    backgroundColor: colors.primary[100],
    alignItems: 'center',
  },
  shareText: {
    fontSize: 14,
    fontWeight: '600',
    color: colors.primary[700],
    fontFamily: fontFamily.body,
  },
})
